import { signalsBumped } from '#shared';

import type { AppDispatch } from '#shared';
import type { EntityChangeEventFrame } from './serverMessage';

export interface CaseTimelineSignal {
  onCaseTouch(frame: EntityChangeEventFrame): void;
  dispose(): void;
}

export const createCaseTimelineSignal = (
  dispatch: AppDispatch,
  delayMs = 1_000,
): CaseTimelineSignal => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  return {
    onCaseTouch() {
      if (timer !== undefined) {
        return;
      }
      timer = setTimeout(() => {
        timer = undefined;
        dispatch(signalsBumped(['caseTimeline']));
      }, delayMs);
    },
    dispose() {
      if (timer !== undefined) {
        clearTimeout(timer);
        timer = undefined;
      }
    },
  };
};
